import { useNavigate } from 'react-router-dom';
import React from 'react';
import { CardSimple } from '../../ui';
import logo from '../../ui/assets/logo.png';
import { Page } from '../../components';

import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import HomeOutlined from '@mui/icons-material/StorefrontOutlined';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import ContactMailOutlinedIcon from '@mui/icons-material/ContactMailOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import CelebrationOutlinedIcon from '@mui/icons-material/CelebrationOutlined';
import LoyaltyOutlinedIcon from '@mui/icons-material/LoyaltyOutlined';
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import TouchAppOutlinedIcon from '@mui/icons-material/TouchAppOutlined';
import CloudSyncOutlinedIcon from '@mui/icons-material/CloudSyncOutlined';
import PaymentOutlinedIcon from '@mui/icons-material/PaymentOutlined';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import SmartphoneOutlinedIcon from '@mui/icons-material/SmartphoneOutlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import BrushOutlinedIcon from '@mui/icons-material/BrushOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';

export function Business() {
    const navigate = useNavigate();

    const arrowClick = () => {
        window.history.back();
    }

    const homeClick = () => {
        navigate('/');
    }

    return (<Page visibleBottomNavigation={false}>
        <div>
            {/* Header */}
            <div className='landing-page w-100 d-flex justify-content-center align-items-center text-primary border-bottom border-2 bg-tertiary'>
                <button className='btn btn-link' onClick={arrowClick}>
                    <ArrowBackOutlinedIcon fontSize="large" className="fs-4" />
                </button>
                <div className='container d-flex justify-content-center align-items-center'>
                    <img src={logo} alt="logo" style={{ height: '50px' }} className='pe-none' unselectable="on" />
                    <span className='fw-bold fs-1'>
                        Kangury
                    </span>
                </div>
                <button className='btn btn-link'>
                    <HomeOutlined fontSize="large" className="fs-4 text-primary" onClick={homeClick} />
                </button>
            </div>

            {/* Hero Section */}
            <Section>
                <div className="text-center text-tertiary">
                    <h1 className='fw-bold mb-3'>Kangury per il tuo Business</h1>
                    <p className='fs-5 mb-4' style={{ maxWidth: '700px', margin: '0 auto' }}>
                        Trasforma le tue campagne con <strong>foto smart NFC</strong>: il gadget promozionale innovativo che stupisce i clienti
                        e crea un ponte tra il mondo fisico e quello digitale.
                    </p>
                    <p className='fs-6 mb-4'>
                        Basta avvicinare lo smartphone alla foto per accedere a contenuti esclusivi, video, cataloghi e landing page.
                        <br /><strong>Nessuna app da scaricare. Nessun QR code. Solo un tocco.</strong>
                    </p>
                    <div className='d-flex justify-content-center gap-3 flex-wrap'>
                        <a href="mailto:hello@kangury.it?subject=Richiesta%20campione%20gratuito%20B2B"
                            className='btn rounded-5 fs-6 btn-primary text-tertiary fw-bold ps-4 pe-4 pt-2 pb-2 text-decoration-none'>
                            Richiedi un campione gratuito
                        </a>
                        <a href="mailto:hello@kangury.it?subject=Prenota%20demo%2015%20minuti"
                            className='btn rounded-5 fs-6 btn-tertiary text-primary fw-bold ps-4 pe-4 pt-2 pb-2 text-decoration-none'>
                            Prenota una demo di 15 minuti
                        </a>
                    </div>
                </div>
            </Section>

            <div className='horizontal-line' />

            {/* Come Funziona */}
            <Section bgWhite={true}>
                <h2 className='fw-bold w-100 text-center mb-5 text-tertiary'>
                    Come Funziona
                </h2>
                <div className='row'>
                    <div className='col-12 col-md-4 mb-4 ps-4 pe-4'>
                        <Card
                            title='1. Ordina'
                            text1='Scegli quantità, formato e personalizzazione per il tuo progetto'
                            icon={<ShoppingCartOutlinedIcon fontSize="large" className="text-primary mt-4 ms-4 position-absolute top-0 start-0 translate-middle" />}
                        />
                    </div>
                    <div className='col-12 col-md-4 mb-4 ps-4 pe-4'>
                        <Card
                            title='2. Personalizza'
                            text1='Carica i contenuti che vuoi collegare: video, cataloghi, landing page, social'
                            icon={<BrushOutlinedIcon fontSize="large" className="text-primary mt-4 ms-4 position-absolute top-0 start-0 translate-middle" />}
                        />
                    </div>
                    <div className='col-12 col-md-4 mb-4 ps-4 pe-4'>
                        <Card
                            title='3. Distribuisci'
                            text1={"Consegna le foto ai tuoi clienti: basta un tocco dello smartphone per l'effetto WOW"}
                            icon={<LocalShippingOutlinedIcon fontSize="large" className="text-primary mt-4 ms-4 position-absolute top-0 start-0 translate-middle" />}
                        />
                    </div>
                </div>
            </Section>

            <div className='horizontal-line' />

            {/* Casi d'Uso */}
            <Section>
                <h2 className='fw-bold w-100 text-center mb-5 text-tertiary'>
                    Casi d'Uso
                </h2>
                <div className='row'>
                    <div className='col-6 col-md-4 col-lg-3 mb-4 ps-3 pe-3'>
                        <UseCaseCard
                            title='Gadget per eventi e fiere'
                            icon={<EventOutlinedIcon className='text-primary' style={{ fontSize: '40px' }} />}
                        />
                    </div>
                    <div className='col-6 col-md-4 col-lg-3 mb-4 ps-3 pe-3'>
                        <UseCaseCard
                            title='Smart Flyer'
                            subtitle='Alternativa al volantinaggio'
                            icon={<DescriptionOutlinedIcon className='text-primary' style={{ fontSize: '40px' }} />}
                        />
                    </div>
                    <div className='col-6 col-md-4 col-lg-3 mb-4 ps-3 pe-3'>
                        <UseCaseCard
                            title='Welcome Kit aziendale'
                            icon={<BusinessCenterOutlinedIcon className='text-primary' style={{ fontSize: '40px' }} />}
                        />
                    </div>
                    <div className='col-6 col-md-4 col-lg-3 mb-4 ps-3 pe-3'>
                        <UseCaseCard
                            title='Biglietti da visita evoluti'
                            icon={<ContactMailOutlinedIcon className='text-primary' style={{ fontSize: '40px' }} />}
                        />
                    </div>
                    <div className='col-6 col-md-4 col-lg-3 mb-4 ps-3 pe-3'>
                        <UseCaseCard
                            title='Packaging esperienziale'
                            icon={<Inventory2OutlinedIcon className='text-primary' style={{ fontSize: '40px' }} />}
                        />
                    </div>
                    <div className='col-6 col-md-4 col-lg-3 mb-4 ps-3 pe-3'>
                        <UseCaseCard
                            title='Inviti premium per eventi'
                            icon={<CelebrationOutlinedIcon className='text-primary' style={{ fontSize: '40px' }} />}
                        />
                    </div>
                    <div className='col-6 col-md-4 col-lg-3 mb-4 ps-3 pe-3'>
                        <UseCaseCard
                            title='Programmi fedeltà'
                            icon={<LoyaltyOutlinedIcon className='text-primary' style={{ fontSize: '40px' }} />}
                        />
                    </div>
                    <div className='col-6 col-md-4 col-lg-3 mb-4 ps-3 pe-3'>
                        <UseCaseCard
                            title='Direct Mail con video'
                            icon={<VideocamOutlinedIcon className='text-primary' style={{ fontSize: '40px' }} />}
                        />
                    </div>
                </div>
            </Section>

            <div className='horizontal-line' />

            {/* Perché Kangury */}
            <Section bgWhite={true}>
                <h2 className='fw-bold w-100 text-center mb-5 text-tertiary'>
                    Perché Kangury
                </h2>
                <div className='row'>
                    <div className='col-12 col-md-6 col-lg-4 mb-4 ps-4 pe-4'>
                        <Card
                            title='Effetto WOW garantito'
                            text1='Un gadget che nessuno si aspetta: la foto prende vita con un semplice tocco'
                            icon={<AutoAwesomeOutlinedIcon fontSize="large" className="text-primary mt-4 ms-4 position-absolute top-0 start-0 translate-middle" />}
                        />
                    </div>
                    <div className='col-12 col-md-6 col-lg-4 mb-4 ps-4 pe-4'>
                        <Card
                            title='Nessun QR code, basta un tocco'
                            text1='Tecnologia NFC invisibile: niente codici da inquadrare, esperienza immediata'
                            icon={<TouchAppOutlinedIcon fontSize="large" className="text-primary mt-4 ms-4 position-absolute top-0 start-0 translate-middle" />}
                        />
                    </div>
                    <div className='col-12 col-md-6 col-lg-4 mb-4 ps-4 pe-4'>
                        <Card
                            title='Cloud aggiornabile'
                            text1='Aggiorna i contenuti anche dopo la distribuzione: il cloud resta sempre accessibile'
                            icon={<CloudSyncOutlinedIcon fontSize="large" className="text-primary mt-4 ms-4 position-absolute top-0 start-0 translate-middle" />}
                        />
                    </div>
                    <div className='col-12 col-md-6 col-lg-4 mb-4 ps-4 pe-4'>
                        <Card
                            title='Nessun costo ricorrente'
                            text1='Si paga una volta, il cloud è incluso per sempre. Nessun abbonamento nascosto'
                            icon={<PaymentOutlinedIcon fontSize="large" className="text-primary mt-4 ms-4 position-absolute top-0 start-0 translate-middle" />}
                        />
                    </div>
                    <div className='col-12 col-md-6 col-lg-4 mb-4 ps-4 pe-4'>
                        <Card
                            title='Made in Italy'
                            text1={"Prodotto e spedito dall'Italia, con la qualità e la cura del design italiano"}
                            icon={<FlagOutlinedIcon fontSize="large" className="text-primary mt-4 ms-4 position-absolute top-0 start-0 translate-middle" />}
                        />
                    </div>
                    <div className='col-12 col-md-6 col-lg-4 mb-4 ps-4 pe-4'>
                        <Card
                            title='95%+ smartphone compatibili'
                            text1='Funziona con la stragrande maggioranza degli smartphone in circolazione'
                            icon={<SmartphoneOutlinedIcon fontSize="large" className="text-primary mt-4 ms-4 position-absolute top-0 start-0 translate-middle" />}
                        />
                    </div>
                </div>
            </Section>

            <div className='horizontal-line' />

            {/* Pricing Indicativo */}
            <Section>
                <h2 className='fw-bold w-100 text-center mb-3 text-tertiary'>
                    Pricing Indicativo
                </h2>
                <p className='text-center text-tertiary mb-5'>
                    Prezzo per unità, in base alla quantità ordinata. Personalizzazioni e formati speciali su richiesta.
                </p>
                <div className='row justify-content-center'>
                    <div className='col-6 col-md-3 mb-4 ps-3 pe-3'>
                        <PricingCard
                            quantity='10 – 50 pz'
                            price='€8 – €10'
                        />
                    </div>
                    <div className='col-6 col-md-3 mb-4 ps-3 pe-3'>
                        <PricingCard
                            quantity='50 – 200 pz'
                            price='€5 – €7'
                        />
                    </div>
                    <div className='col-6 col-md-3 mb-4 ps-3 pe-3'>
                        <PricingCard
                            quantity='200 – 500 pz'
                            price='€3 – €5'
                        />
                    </div>
                    <div className='col-6 col-md-3 mb-4 ps-3 pe-3'>
                        <PricingCard
                            quantity='1000+ pz'
                            price='€2 – €3'
                            highlight={true}
                        />
                    </div>
                </div>
                <p className='text-center text-tertiary mt-2' style={{ fontSize: '14px' }}>
                    I prezzi sono indicativi e possono variare in base al formato, personalizzazione e quantità. Contattaci per un preventivo su misura.
                </p>
            </Section>

            <div className='horizontal-line' />

            {/* CTA Section */}
            <Section bgWhite={true}>
                <div className='text-center text-tertiary'>
                    <h2 className='fw-bold mb-3'>Pronto a stupire i tuoi clienti?</h2>
                    <p className='fs-5 mb-4' style={{ maxWidth: '600px', margin: '0 auto' }}>
                        Richiedi un campione gratuito o prenota una demo di 15 minuti per scoprire come Kangury può trasformare le tue campagne.
                    </p>
                    <div className='d-flex justify-content-center gap-3 flex-wrap mb-4'>
                        <a href="mailto:hello@kangury.it?subject=Richiesta%20campione%20gratuito%20B2B"
                            className='btn rounded-5 fs-6 btn-primary text-tertiary fw-bold ps-4 pe-4 pt-2 pb-2 text-decoration-none'>
                            <EmailOutlinedIcon className='me-2' style={{ fontSize: '20px' }} />
                            Richiedi un campione gratuito
                        </a>
                        <a href="mailto:hello@kangury.it?subject=Prenota%20demo%2015%20minuti"
                            className='btn rounded-5 fs-6 btn-tertiary text-primary fw-bold ps-4 pe-4 pt-2 pb-2 text-decoration-none'>
                            <CalendarMonthOutlinedIcon className='me-2' style={{ fontSize: '20px' }} />
                            Prenota una demo di 15 minuti
                        </a>
                    </div>
                </div>
            </Section>

            {/* Footer Contact */}
            <div className={`w-100 p-4 d-flex justify-content-center align-items-center bg-tertiary bg-opacity-50 pt-5 pb-5`}>
                <div className="container text-center">
                    <h5 className='fw-bold text-tertiary'>
                        Contattaci
                    </h5>
                    <div className='fs-5 mb-2'>
                        <a href="mailto:hello@kangury.it" className='text-tertiary'>hello@kangury.it</a>
                    </div>
                    <div className='fs-6'>
                        <a href="https://kangury.it" target="_blank" rel="noreferrer" className='text-tertiary'>kangury.it</a>
                    </div>
                </div>
            </div>

            {/* Copyright Footer */}
            <div className='w-100 d-flex justify-content-center align-items-center text-primary border-bottom border-2 bg-tertiary' style={{ padding: '12px 0' }}>
                <img src={logo} alt="logo" style={{ height: '30px' }} className='pe-none me-2' unselectable="on" />
                Kangury | Copyright &copy; 2024
            </div>

        </div>
    </Page>);
}

const Card = ({ title, text1, text2, otherClass, icon }) => {
    return (
        <CardSimple
            otherClass={otherClass ?? "bg-tertiary bg-opacity-75 position-relative h-100 shadow"}
            children={<div className='text-center'>
                <div className='fs-5 fw-bold text-primary'>{title}</div>
                <div className='fw-bold text-white'>
                    {text1}
                </div>
                {text2 && <div className='fw-bold text-white'>
                    {text2}
                </div>}
                {icon}
            </div>} />
    );
}

const UseCaseCard = ({ title, subtitle, icon }) => {
    return (
        <CardSimple
            otherClass="bg-tertiary bg-opacity-75 h-100 shadow text-center d-flex flex-column align-items-center justify-content-center"
            children={<div>
                {icon}
                <div className='fs-6 fw-bold text-primary mt-2'>{title}</div>
                {subtitle && <div className='text-white' style={{ fontSize: '13px' }}>{subtitle}</div>}
            </div>} />
    );
}

const PricingCard = ({ quantity, price, highlight }) => {
    return (
        <CardSimple
            otherClass={`h-100 shadow text-center ${highlight ? 'bg-primary' : 'bg-tertiary bg-opacity-75'}`}
            children={<div>
                <div className={`fs-6 fw-bold ${highlight ? 'text-tertiary' : 'text-primary'}`}>{quantity}</div>
                <div className={`fs-4 fw-bold mt-2 ${highlight ? 'text-tertiary' : 'text-white'}`}>{price}</div>
                <div className={`mt-1 ${highlight ? 'text-tertiary' : 'text-white'}`} style={{ fontSize: '13px' }}>per unità</div>
            </div>} />
    );
}

const Section = ({ children, bgWhite }) => {
    return (
        <div className={`w-100 p-4 d-flex justify-content-center align-items-center ${bgWhite ? 'bg-white' : 'bg-tertiary bg-opacity-25'} pt-5 pb-5`}>
            <div className="container">
                {children}
            </div>
        </div>
    );
}
